import {Pipe, PipeTransform} from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Observable,forkJoin, interval } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
    name: 'dateAgo',
    pure: true
})
export class DateAgoPipe implements PipeTransform {


    constructor(private t:TranslateService){
    }
    transform(value: any, args?: any): Observable<string> {
        return forkJoin([
            'TIME.JUST_NOW',
            'TIME.YEAR',
            'TIME.MONTH',
            'TIME.WEEK',
            'TIME.DAY',
            'TIME.HOUR',
            'TIME.MIN',
            'TIME.SEC',
            'TIME.AGO',
            'TIME.IN_ABOUT'
        ].map(s => this.t.get(s))).pipe(map(([justNow,year,month,week,day,hour,min,sec,ago,inAbout]) => {
            if (value) {
                // console.log('date-ago',value);
                let seconds = Math.floor((+new Date() - +new Date(value)) / 1000);
    
                let inFuture = true;
    
                if ( seconds < 0 ) {
                    inFuture = false;
                    seconds = Math.abs ( seconds );
                }
    
                if (seconds < 29) // less than 30 seconds ago will show as 'Just now'
                    return justNow;
                const intervals = {
                    
                }
                intervals[year] = 31536000
                intervals[month] = 2592000
                intervals[week] = 604800
                intervals[day] = 86400
                intervals[hour] = 3600
                intervals[min] = 60
                intervals[sec] = 1
                
                let counter;
                for (const i in intervals) {
                    counter = Math.floor(seconds / intervals[i]);
                    let cardinal = 's';
                    if ( counter === 1 ) {
                        cardinal = '';
                    }
                    if (counter > 0) {
                        if ( inFuture ) {
                            return counter + ' ' + i + cardinal + ' ' +  ago;
                        }
                        return inAbout + ' ' + counter + ' ' + i + cardinal;
    
                        /* if (counter === 1) {
                            return counter + ' ' + i + ' ago'; // singular (1 day ago)
                        } else {
                            return counter + ' ' + i + 's ago'; // plural (2 days ago)
                        } */
                    }
                }
            }
            return value;
        }))
        
    }

}